import { render, staticRenderFns } from "./SwitchTypeOfTrip.vue?vue&type=template&id=6bd65d7c&"
import script from "./SwitchTypeOfTrip.vue?vue&type=script&lang=js&"
export * from "./SwitchTypeOfTrip.vue?vue&type=script&lang=js&"
import style0 from "./SwitchTypeOfTrip.vue?vue&type=style&index=0&lang=scss&scope=app%2Fassets%2Fstylesheets%2Fcomponents%2Flodging-filter&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports